import PropTypes from 'prop-types';
import React from 'react';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';

import { Link } from 'react-router';
import CollapsibleSection from 'modules/Common/components/CollapsibleSection';

import {localTimeShort} from 'utils/LocalDateTimeHelper';
import { toSlug } from 'utils';

export default function HorseRacingNonRunners(props) {
  require("./HorseRacingNonRunners.scss");

  const title = "Today's Non-Runners";

  return <div className="horse-racing-non-runners">
    <MetaDataWrapper title={title}/>
    <h1 className="page-main-title">{title}</h1>
    <section className="hr-nr-meetings">
      {
        props.meetings && props.meetings.length > 0 ?
        props.meetings.map(({
          races,
          meeting_summary: {
            meeting_reference: {
              id: meetingId
            },
            date: meetingDate,
            course: {
              name: courseName,
              feed_source
            }
          }
        }) => {
          const courseNameSlug = toSlug(courseName);

          const meetingPageUrl = `/racing/meeting/${meetingDate}/${courseNameSlug}/${meetingId}`

          return <CollapsibleSection key={meetingId} feedLogo={feed_source} title={courseName} linkTo={meetingPageUrl}>
            {races.map(({
              race_summary: {
                race_summary_reference: {
                  id: raceId
                },
                time,
                date,
                name: raceName
              },
              rides
            }) =>
              <div key={raceId} className="hr-nr-race">
                <div className="hr-nr-race-time">
                  <Link to={`/racing/racecards/${meetingDate}/${courseNameSlug}/racecard/${raceId}/${toSlug(raceName)}`}>
                    {localTimeShort(`${date}T${time}Z`)}
                  </Link>
                </div>
                <div className="hr-nr-race-rides">{rides.map(({
                    ride_reference: {
                      id: rideId
                    },
                    cloth_number,
                    horse: {
                      horse_reference: {
                        id: horseId
                      },
                      name: horseName
                    }
                  }) => {
                  return <span className="hr-nr-race-ride" key={rideId}>{cloth_number} <Link to={`/racing/profiles/horse/${horseId}`}>{horseName}</Link></span>;
                })}</div>
              </div>
            )}
          </CollapsibleSection>
        })
      :
        <div className="hr-racing-racecards-none">
          <p>No meetings found</p>
        </div>
      }
    </section>
  </div>
}

HorseRacingNonRunners.propTypes = {
  meetings: PropTypes.array
};



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingNonRunners.js